module.exports = __webpack_public_path__ + "static/media/01.7a66edfc.jpg";